<empty-layout *ngIf="layout === 'empty'"></empty-layout>
<!-- Material -->
<material-layout *ngIf="layout === 'material'"></material-layout>
